import React from 'react';

const DownloadApp = props => {
    let productType = 'Eyeglasses, Sunglasses and Contact Lenses.';
    if (props.location.pathname.indexOf('sunglass') !== -1) productType = 'Sunglasses.';
    else if (props.location.pathname.indexOf('eyeglass') !== -1) productType = 'Eyeglasses.';
    else if (props.location.pathname.indexOf('contact') !== -1 || props.location.pathname.indexOf('lens') !== -1) productType = 'Contact Lens.';
    return (
        <div className="container-fluid">
            <div className="margin-b20 col-sm-12 text-center downloadApp fs16 fw700">
                <span>Download Lenskart App to buy <a href="https://onelink.to/lenskart2" className="color-green">{`${productType}`}</a></span>
            </div>
        </div>
    );
};

export default DownloadApp;
